import React from "react";
import './TodosLoading.css'

function TodosLoading(){

  return (
    <div className="TodosLoading__Container">
      <div className="TodosLoading"></div>
    </div>
    
  )
}

export { TodosLoading };